import module from '../module';
import * as _ from 'lodash';
import Constants from '../../../utils/CommonConstants';
import moment from 'moment';
import {utils} from "../../../utils/shopifyInjector/utils";
import {communicationService} from "../../../services/communicationService";
import {commandKeys} from "../../../shared/commandKeys";
import CommonConstants from "../../../utils/CommonConstants";


class CartService {

    static $inject = [ '$http', 'Session', 'cartonomyConfig', '$rootScope', 'LocalForageService', '$timeout', 'Message', 'HeapService', 'RealTimeUpdateService', '$translate' ];

    constructor(httpService, sessionService, cartonomyConfig, rootScope, localForageService, timeoutService, messageService, HeapService, RealTimeUpdateService, $translate) {
        this._httpService = httpService;
        this._sessionService = sessionService;
        this._rootScope = rootScope;
        this._urlBase = cartonomyConfig.ApiV2 + 'cart';
        this._urlBaseShopify = cartonomyConfig.ApiV2 + 'shopify';
        //this._sessionStorage = sessionStorage;
        this._localForageService = localForageService;
        this._isGroupOrder = false;
        this._timeoutService = timeoutService;
        this._messageService = messageService;
        this._heapService = HeapService;
        this._lastLeftCart = null;
        this.$translate = $translate;

        this.lastCartRequest = null;
        this._invitationType = Constants.InvitationTypes.normal;
        this._inviteCode = null;
        this._inviteSingleLink = null;
        this._inviteMorePeopleMode = false;
        this.shareTokenPromise = null;
    }

    static isGroupOrder(cart) {
        if (!cart) {
            return false;
        }

        return cart.cartType === 'GROUP' || cart.participants && cart.participants.length > 1;
    }

    async clearCart(){
        if (!(await this._sessionService.loggedIn())) {
            await this.resetCart();
            return new Promise(resolve => resolve());
        }

        return this._httpService.delete(this._urlBase + '/clearCart').then(async() => {
            await this.resetCart();
        });
    }

    async deleteCart() {

        if (!(await this._sessionService.loggedIn())) {
            await this.resetCart();
            return new Promise(resolve => resolve());
        }

        return this.getCart().then(cart => {
            cart.createdOn = undefined; // in order to block main controller notification about removed carts
            return this._httpService.delete(this._urlBase).then(async () => {
                await this.resetCart();
            });
        });
    }

    getLastLeftCart() {
        return this._lastLeftCart;
    }

    async getUserLastCart() {
        if (!(await this._sessionService.loggedIn())) {
            return "";
        }

        if (this.lastCartRequest)
            return this.lastCartRequest;

        this.lastCartRequest = this._httpService.get(this._urlBase + '/laststatus')
                                   .then(response => {
                                       return response.data;
                                   })
                                   .finally(() => {
                                       this.lastCartRequest = null;
                                   });

        return this.lastCartRequest;
    }

    async isCartOwner() {
        let cart = await this.getCart();
        let cartOwner = _.find(cart.participants, participant => participant.status === `OWNER`);
        let getEmail = await this._sessionService.getUserEmail();
        let isCartOwner = getEmail === (cartOwner && cartOwner.email);

        return isCartOwner;
    }

    isLastLeftCartDeadlineExpired() {
        if (!this._lastLeftCart || !this._lastLeftCart.closeOn) {
            return false;
        }
        const deadlineTime = moment(this._lastLeftCart.closeOn).subtract(15, 'minutes');
        return moment().isAfter(deadlineTime);
    }

    async leaveCart() {
        if (!(await this._sessionService.loggedIn())) {
            await this.resetCart();
            return;
        }

        this._lastLeftCart = await this.getCart();
        await this._httpService.post(this._urlBase + '/leave');

        if (await this._sessionService.isInvite()) {
            await this._sessionService.clearSessionDetails();
        }
        await this.resetCart();
    }

    async checkOutCart() {
        return this._httpService.get(this._urlBase + '/checkout');
    }

    async clearLocalCart() {
        await this._localForageService.remove(Constants.SessionStorage.CART);
    }

    async getLocalCart() {
        const cart = await this._localForageService.retrieve(Constants.SessionStorage.CART);
        if (cart) {
            return JSON.parse(cart);
        }
        return null;
    }

    getCartReport(status, pageIndex = 0, pageSize = 1000) {
        return this._httpService.get(`${this._urlBase}/cartsReport`, {
            params: {
                pageIndex,
                pageSize,
                status
            }
        })
                   .then(response => response.data)
                   .catch(error => {
                       throw error;
                   });
    }

    async getCart(cartId, fromCache = true) {
        let promise = await this._sessionService.getCartReference();
        if (fromCache && promise) {
            this.setAddCartButtonState(promise);
            return promise;
        }

        let isLoggedIn = await this._sessionService.loggedIn();
        if (isLoggedIn) {
 			let url = this._urlBase
            if(cartId)
            {
                url = this._urlBase+ '/' + cartId;
            }

            return this._httpService.get(url).then(response => {
                const cart = response.data;
                this.updateGroupOrderStatus(cart);
                this._sessionService.setCartReference(cart);
 				if(this._rootScope.retailer && this._rootScope.retailer.customCartNames === '1'){
                  communicationService.requestToParent(commandKeys.updateMyCartButtonText, {cartNameValue: cart.cartName});
                }

                this.setAddCartButtonState(cart);
                return cart;
            });
        } else {
            const cart = await this.getLocalCart();
            let response = cart || {
                items: [],
                participants: [],
                fulfillment: {}
            };
            this.setAddCartButtonState(cart);
            this._sessionService.setCartReference(response);
            return response;
        }
    }

    async setAddCartButtonState(cart) {
        if (cart) {
            let cartOwner = _.find(cart.participants, participant => participant.status === `OWNER`);
            let getEmail = await this._sessionService.getUserEmail();
            let isOwner = getEmail === (cartOwner && cartOwner.email);
            if (this._rootScope.retailer) {
                if (this._rootScope.retailer.cartonomyMode !== Constants.CartonomyMode.marketing ||
                    ((isOwner || cart.participants.length == 0) && cart.participants.filter(p => p.status === 'JOINED').length === 0)) {
                    communicationService.requestToParent(commandKeys.enableAddToCartButton, {});
                } else {
                    communicationService.requestToParent(commandKeys.removeAddToCartButton, {});
                }
            }
        }
    }

    async getCartById(cartId){
        //let response = await this._httpService.get(this._urlBase + '/' + cartId);

        let promise = this._httpService.get(this._urlBase+ '/' + cartId)
        .then(response => {
            const cart = response.data;
            //this.updateGroupOrderStatus(cart);
            return cart;
        });

        this._sessionService.setCartReference(promise);

        return promise;
    }

    async getCartByInvitationCode(invitationCode) {
        let promise = this._httpService.get(this._urlBase + '/invitation/' + invitationCode)
            .then(response => {
                const cart = response.data;
                //this.updateGroupOrderStatus(cart);
                return cart;
            });
        return promise;
    }

    updateGroupOrderStatus(cart) {
        const isGroupOrder = cart ? CartService.isGroupOrder(cart) : false;
        if (isGroupOrder != this._isGroupOrder) {
            this._isGroupOrder = isGroupOrder;
            this.onGroupOrderStatusChanged();
        }
    }

    onGroupOrderStatusChanged() {
        this._rootScope.$emit(Constants.Events.GROUP_ORDER_STATUS_CHANGED);
    }

    async isGroupOrder(cart) {

        if (!(await this._sessionService.loggedIn())) {
            return false;
        }

        if (cart) {
            return CartService.isGroupOrder(cart);
        }

        return CartService.isGroupOrder(await this.getCart());
    }

    async getCartAmount() {
        let cart = await this.getCart();
        let items = _.cloneDeep(cart.items);

        let amount = _.sumBy(items, (item) => {
            return item.price * item.quantity;
        });

        return amount;
    }

    async _updateLocalCart(cart) {
        await this._localForageService.store(Constants.SessionStorage.CART, JSON.stringify(cart));
        //this._sessionService.setCartReference(new Promise(resolve => resolve(cart)));
    }

    async addProductFromShopify(productVariantId, quantity, productOptions) {
        const params = {
            externalProductId: productVariantId,
            quantity: quantity,
            itemComment: "",
            itemOption: productOptions,
            itemName: ""
        };

        try {
            const response = await this._httpService.post(this._urlBase + '/item', params);
            let cart = response.data;

            this._heapService.track('AddItem', {itemId: productVariantId, quantity: quantity});

            this._sessionService.setCartReference(new Promise(resolve => resolve(cart)));
            this.updateGroupOrderStatus(cart);
        } catch (exception) {
            throw exception;
        }
    }

    async addProductFromCustomSite(productVariantId, quantity, name, image, price, productOptions, productUrl) {
        const params = {
            externalProductId: productVariantId,
            quantity: quantity,
            itemComment: "",
            itemOption: productOptions,
            itemName: name,
            image: image,
            price: price,
            productUrl: productUrl
        };

        try {
            const response = await this._httpService.post(this._urlBase + '/item', params);
            let cart = response.data;

            this._heapService.track('AddItem', {itemId: productVariantId, quantity: quantity});

            this._sessionService.setCartReference(new Promise(resolve => resolve(cart)));
            this.updateGroupOrderStatus(cart);
        } catch (exception) {
            throw exception;
        }
    }

    async addProduct(product) {

        let cart = await this.getCart();

        let existingItem;

        if (await this._sessionService.loggedIn()) {
            const email = await this._sessionService.getUserEmail();
            existingItem = cart.items && cart.items.find(item => item.catalogProductId === product.id && item.participantEmail === email);
        } else {
            existingItem = cart.items && cart.items.find(item => item.catalogProductId === product.id);
        }

        if (existingItem) {
            existingItem.quantity += product.quantity;
            return this.updateItem(existingItem, true);
        }

        const onCartReceived = (cart, item) => {
            this._sessionService.setCartReference(new Promise(resolve => resolve(cart)));
            this._rootScope.$broadcast(Constants.BroadcastMessages.DISPLAY_POPUP_BAG, item ? item.id : null);

            this.updateGroupOrderStatus(cart);
        };

        if (!(await this._sessionService.loggedIn())) {

            let itemId = this._itemId || 1;

            const item = {
                catalogProductId: product.id,
                catalogProductImage: product.image,
                quantity: product.quantity || 1,
                comment: product.comment,
                itemName: product.name,
                itemOption: "",
                price: product.price,
            };

            if (!cart.items) {
                cart.items = [];
            }

            //noinspection JSReferencingMutableVariableFromClosure
            while (cart.items.find(item => item.id === itemId)) {
                itemId++;
            }

            item.id = itemId;

            this._itemId = itemId + 1;

            item.total = item.price * item.quantity;

            cart.items.push(item);

            this._updateLocalCart(cart);
            onCartReceived(cart, item);
            return;
        }

        const params = {
            catalogItemId: product.id,
            quantity: product.quantity || 1,
            itemComment: product.comment,
            itemOption: "",
            itemName: ""
        };

        const response = await this._httpService.post(this._urlBase + '/item', params);

        cart = response.data;
        const email = await this._sessionService.getUserEmail();
        const item = cart.items && cart.items.find(item => item.catalogProductId === product.id && item.participantEmail === email);

        onCartReceived(cart, item);
    }

    async updateItem(item, displayPopupBag) {
        if (!(await this._sessionService.loggedIn())) {
            const cart = await this.getCart();

            let existingItem = cart.items && cart.items.find(i => i.id === item.id);
            if (!existingItem) {
                // TODO: show error message
                return;
            }
            existingItem.quantity = item.quantity;
            existingItem.comment = item.comment;
            await this._updateLocalCart(cart);
            this._sessionService.setCartReference(new Promise(resolve => resolve(cart)));
            if (displayPopupBag) {
                this._rootScope.$broadcast(Constants.BroadcastMessages.DISPLAY_POPUP_BAG, item.id);
            } else {
                this._rootScope.$broadcast(Constants.BroadcastMessages.POPUP_BAG_CHANGED);
            }
            return;
        }

        const params = {
            id: item.id,
            catalogProductId: item.catalogProductId,
            quantity: item.quantity,
            itemComment: item.comment,
            itemOption: item.itemOption,
            isShared: item.isShared
        };

        const response = await this._httpService.put(this._urlBase + '/item', params);

        const cartItem = response.data;

        let cart = await this._sessionService.getCartReference();

        if (!cart) {
            this._rootScope.$broadcast(Constants.BroadcastMessages.POPUP_BAG_CHANGED);
            return;
        }


        if (cart.items) {
            for (let i = 0; i < cart.items.length; i++) {
                if (cart.items[ i ].id === cartItem.id) {
                    cartItem.product = cartItem.product || cart.items[ i ].product;
                    cart.items[ i ] = cartItem;
                    break;
                }
            }
        }

        this._sessionService.setCartReference(cart);

        if (displayPopupBag) {
            this._rootScope.$broadcast(Constants.BroadcastMessages.DISPLAY_POPUP_BAG, item.id);
        } else {
            this._rootScope.$broadcast(Constants.BroadcastMessages.POPUP_BAG_CHANGED);
        }
    }

    async deleteItem(id) {

        if (!(await this._sessionService.loggedIn())) {

            const cart = await this.getCart();

            const index = cart.items && cart.items.findIndex(item => item.id === id);
            if (index < 0) {
                // TODO: show error message
                return false;
            }
            cart.items.splice(index, 1);
            this._updateLocalCart(cart);
            this._sessionService.setCartReference(null);
            this._rootScope.$broadcast(Constants.BroadcastMessages.POPUP_BAG_CHANGED);
            return true;
        }

        const res = await this._httpService.delete(this._urlBase + '/item/' + id);

        this._sessionService.setCartReference(null);
        this._rootScope.$broadcast(Constants.BroadcastMessages.POPUP_BAG_CHANGED);
        return res;
    }

    sendInvites(emails) {
        return this._httpService.post(this._urlBase + '/participants', _.map(emails, (email) => {
            return {
                email: email
            };
        }));
    }

    removeParticipant(participantEmail) {
        return this._httpService.delete(`${this._urlBase}/participant?participantEmail=${encodeURIComponent(participantEmail)}`);
    }

    getParticipants() {
        return this._httpService.get(this._urlBase + '/participants')
                   .then(response => {
                       return response.data;
                   });
    }

    transferOwner(newOwnerParticipantId) {
        return this._httpService.post(`${this._urlBase}/transferOwner/${newOwnerParticipantId}`)
                   .then(response => {
                       return response.data;
                   });
    }

    async isOwner(cart) {
        if (!cart || !cart.participants) {
            return false;
        }

        const userEmail = await this._sessionService.getUserEmail();
        const participant = _.find(cart.participants, participant => participant.email === userEmail);

        return participant && participant.status === Constants.CartDetails.Participant.Status.OWNER;
    }

    async isParticipantOwner(participant) {
        if (!participant)
            return false;

        return participant.status === Constants.CartDetails.Participant.Status.OWNER;

    }

    async resetCart() {
        if (!(await this._sessionService.loggedIn())) {
            await this._localForageService.remove(Constants.SessionStorage.CART);
        }

        this._sessionService.setCartReference(null, false);
        this._rootScope.$broadcast(Constants.BroadcastMessages.POPUP_BAG_CHANGED);
    }

    async getCartProperties() {
        let cart = await this.getCart();

        return {
            isGroupOrder: await this.isGroupOrder(cart),
            isOwner: this.isOwner(cart),
            title: cart.title,
            singlePay: cart.fulfillment.paymentMethod === Constants.CartDetails.PaymentMethods.SINGLE
        };
    }

    async getCartDetails() {

        const fulfillment = (await this.getCart()).fulfillment;

        return {
            deliveryMethod: fulfillment.deliveryMethod || Constants.CartDetails.DeliveryMethods.DEFAULT,
            paymentMethod: fulfillment.paymentMethod || Constants.CartDetails.PaymentMethods.DEFAULT,
            shippingMethod: fulfillment.shippingMethod || Constants.CartDetails.ShippingMethods.DEFAULT,
            deliveryDate: fulfillment.expectedOn,
            deliveryTime: fulfillment.expectedOn,
            deliveryPhone: fulfillment.shippingPhone,
            deliveryAddress: {
                city: fulfillment.shippingCity,
                street: fulfillment.shippingAddress,
                zip: fulfillment.shippingZip,
                aptSuite: fulfillment.shippingAddress2,
                state: fulfillment.shippingState
            }
        };

    }

    async setCartConfiguration(configuration) {
        if (!(await this._sessionService.loggedIn())) {
            const cart = await this.getCart();
            cart.title = configuration.title;
            cart.comment = configuration.comment;
            await this._updateLocalCart(cart);
            this._sessionService.setCartReference(null);
            return;
        }

        await this._httpService.put(this._urlBase, {
            title: configuration.title,
            comment: configuration.comment,
            automaticExpire: configuration.automaticExpire,
            automaticProcess: configuration.automaticProcess,
            sendCloseNotification: configuration.sendCloseNotification,
            orderLimit: configuration.orderLimit,
            orderLimitType: configuration.orderLimitType,
            closeOn: configuration.closeOn,// Must be retailer timezone
            shippingTotal: configuration.shippingTotal,
            taxTotal: configuration.taxTotal,
            cartName: configuration.cartName,
            retailerStoreId: configuration.retailerStoreId
        });
    }

    async setCartDetails(details) {
        let fulfillment = (await this.getCart()).fulfillment;
        console.log('setCartDetails');
        _.assign(fulfillment, {
            deliveryMethod: details.deliveryMethod || fulfillment.deliveryMethod,
            paymentMethod: details.paymentMethod || fulfillment.paymentMethod,
            expectedOn: details.deliveryDate ? moment.utc(details.deliveryDate).format() : fulfillment.expectedOn,
            shippingPhone: details.deliveryPhone || fulfillment.shippingPhone,
            cartInvitationType:  this._invitationType,
            shareToken : this._invitationType == Constants.InvitationTypes.share ? this._inviteCode : null,
            cartName : details.cartName
        });

        if (details.deliveryAddress && (details.deliveryAddress.city || details.deliveryAddress.street || details.deliveryAddress.zip)) {
            fulfillment.shippingCity = details.deliveryAddress.city;
            fulfillment.shippingAddress = details.deliveryAddress.street;
            fulfillment.shippingZip = details.deliveryAddress.zip;
            fulfillment.shippingAddress2 = details.deliveryAddress.aptSuite;
            fulfillment.shippingState = details.deliveryAddress.state;
        }

        const url = this._urlBase + "/fulfillment";

        const response = await this._httpService.put(url, fulfillment);

        this.resetCartInvitationType();

        const cart = await this.getCart();

        cart.fulfillment = response.data;
        

        return response.data;
    }

    async acceptInvite(token, forceInvite) {
        
        const invitationType = this._invitationType;
        const response = await this._httpService.post(this._urlBase + '/invite/accept', {
            token,
            forceInvite
        });

        return {
            alreadyJoined: response.data.alreadyJoined,
            authToken: response.data.authToken,
            userEmail: response.data.user.userName,
            userName: response.data.user.fullName,
            participantToken: response.data.participantToken,
            cartId: response.data.cartId
        };
    }

    async updateCartName(cartName) {
        if (!this._sessionService.loggedIn()) {
            return;
        }

        await this._httpService.put(`${this._urlBase}/updateCartName`, {
            cartName: cartName
        });
    }

    refreshItems() {
        this._sessionService.setCartReference(null);
    }

    async getInvitationCode(){
        return this._httpService.get(this._urlBase + '/getInvitationCode')
        .then(response => {
            return response.data;
        });
    }

    async getShareTokenByCartId(cartId){
        if(!this.shareTokenPromise) {
            this.shareTokenPromise = new Promise(resolve => {
                this._httpService.get(`${this._urlBase}/getShareTokenByCartId/${cartId}`)
                    .then(response => {
                        resolve(response.data);
                    });
            })
        }
        return this.shareTokenPromise
    }

    async getParticipantamounts(cartId){
        return this._httpService.get(`${this._urlBase}/getParticipantamounts/${cartId}`)
            .then(response => {
                return response.data;
            });
    }

    async updateAmountTopay(params){
        return await this._httpService.put(this._urlBase + '/updateParticipantamount', params);
    }

    setInvitationType(value){
        this._invitationType = value;
    }

    getInvitationType(){
        return this._invitationType;
    }

    setInviteCode(value){
        this._inviteCode = value;
    }

    getInviteCode(){
        return this._inviteCode;
    }

    setInviteSingleLink(value){
        this._inviteSingleLink = value;
    }

    getInviteSingleLink(value){
        return this._inviteSingleLink;
    }

    setInviteMorePeopleMode(value){
        this._inviteMorePeopleMode = value;
    }

    getInviteMorePeopleMode(){
        return this._inviteMorePeopleMode;
    }

    resetCartInvitationType(){
        this._inviteMorePeopleMode = false;
        this._inviteCode = null;
        this.shareTokenPromise = null;
        this._invitationType = Constants.InvitationTypes.normal;
        this._inviteSingleLink = null;
    }

    copyClipboard(invitationLink){
        const copyElement = document.createElement("textarea");
        copyElement.style.position = 'fixed';
        copyElement.style.opacity = '0';
        copyElement.textContent = invitationLink;
        copyElement.contentEditable = true;
        copyElement.readOnly = true;
        const body = document.getElementsByTagName('body')[0];
        body.appendChild(copyElement);
        if(utils.isIOSMobile) {

            let range = document.createRange();
            range.selectNodeContents(copyElement);
            var s = window.getSelection();
            s.removeAllRanges();
            s.addRange(range);
            copyElement.setSelectionRange(0, 999999);
        } else {
            copyElement.select();
        }
        document.execCommand('copy');
        body.removeChild(copyElement);
    }

    async confirmContinueCheckoutWhenMatchCartItems() {
        const continueCheckout = await this._messageService.showQuestionPopup(
          this.$translate.instant('client.confirm_checkout.match_items'),
            '',
          this.$translate.instant('client.ok'), this.$translate.instant('client.cancel'));

        return continueCheckout;
    }

    async confirmContinueCheckout(retailerName = 'Shopify') {
        const continueCheckout = await this._messageService.showQuestionPopup(
          this.$translate.instant('client.confirm_checkout'),
            '',
          this.$translate.instant('client.ok'), this.$translate.instant('client.cancel'));

        return continueCheckout;
    }

    async startProcessCheckout(){
        let confirmed = await this._messageService.showQuestionPopup(
          this.$translate.instant('client.start_checkout'),
            '', this.$translate.instant('client.yes'), this.$translate.instant('client.no'), 'md-warn');

        return confirmed;
    }
}

module.service('CartService', CartService);



// WEBPACK FOOTER //
// ./src/modules/shared/services/CartService.js